<template>
  <div class="top-menu">
    <div class="wrap-shrink" @click="setCollect"><Icon class="collect" :name="isCollect ? 'collect' : 'shrink'"></Icon></div>
    <div class="advertisement">
      <marquee
        class="noticeText ng-binding"
        direction="left"
        behavior="alternate"
        scrollamount="100"
        scrolldelay="2000"
        loop="100"
        width="100%"
        onmouseover="this.stop();"
        onmouseout="this.start();"
        style="width: 100%;letter-spacing:1px"
      >
        {{advertisement}}
      </marquee>
    </div>
    <div class="wrap-user-menu"><user-menu :username="username"></user-menu></div>
  </div>
</template>

<script>
import UserMenu from './usermenu';
import { getInfo } from '@/utils/auth';
import website from '@/utils/website'
export default {
  components: {
    'user-menu': UserMenu
  },
  data() {
    return {
      username: '',
      advertisement:''
    };
  },
  props: {
    isCollect: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setCollect() {
      this.$listeners.setCollect(this.isCollect);
    }
  },
  created() {
    let info = getInfo();
    let tp = typeof info;
    if (tp == 'string') {
      this.username = JSON.parse(info).user.username;
    }
    this.advertisement = website.advertisement;
  }
};
</script>
<style scoped lang="scss">
$height: 56px;
.top-menu {
  height: $height;
  line-height: $height;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #f3f3f3;
  .wrap-shrink {
    width: 60px;
    height: $height;
    display: flex;
    align-items: center; //垂直居中
    justify-content: center; //水平居中
    .collect {
      &:hover {
        cursor: pointer;
      }
    }
  }
  .advertisement {
    position: absolute;
    top: 0px;
    left: 60px;
    width: calc(100% - 70%);
  }
  .wrap-user-menu {
    height: $height;
    position: absolute;
    right: 0px;
    top: 0px;
    margin-right: 50px;
    padding: 0px 10px;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topMenu.vue